module.exports = __webpack_public_path__ + "img/org4.f13c61ed.png";